/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { faGear } from '@fortawesome/pro-regular-svg-icons/faGear';
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { array } from '@codegrade/utils';
import * as comp from '@/components';
import CourseName from '@/components/CourseName';
import * as models from '@/models';
import { UIPrefsStore } from '@/store';
export default tsx.component({
    name: 'course-list-item',
    functional: true,
    props: {
        course: p(models.Course).required,
        currentId: p(Number).optional,
        routeName: p(String).required,
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(_, ctx) {
        const { course, routeName, currentId } = ctx.props;
        const selected = course.id === currentId;
        const manageSelected = selected && routeName === 'manage_course';
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        function maybeEmit() {
            if (ctx.listeners['open-menu'] != null) {
                const listeners = ctx.listeners['open-menu'];
                array.ensureArray(listeners).forEach(listener => listener({
                    header: () => <CourseName course={course} hideDate/>,
                    component: 'assignment-list',
                    data: { course },
                    reload: true,
                }));
            }
        }
        const manageRoute = {
            name: 'manage_course',
            params: { courseId: course.id.toString(10) },
            query: { sbloc: 'c' },
        };
        const classes = {
            selected: selected && !manageSelected,
            'light-selected': selected,
            'sidebar-list-item': true,
            'course-list-item': true,
        };
        const aStyle = {
            textDecoration: 'none',
            color: 'inherit',
            lineHeight: 1.1,
        };
        let badgeVariant;
        if (UIPrefsStore.darkMode()) {
            badgeVariant = selected ? 'dark' : 'light';
        }
        else {
            badgeVariant = selected ? 'light' : 'primary';
        }
        let manageLink;
        if (course.canManage) {
            manageLink = (<router-link style={aStyle} class={['sidebar-item manage-link', { selected: manageSelected }]} to={manageRoute}>
                    <comp.Icon icon={faGear}/>
                </router-link>);
        }
        return (<li class={classes}>
                <a tabindex={0} class="sidebar-item course-name flex-grow-1 text-truncate" style={aStyle} onClick={maybeEmit} onKeyup={tsx.modifiers.enter(maybeEmit)}>
                    <CourseName course={course} badge-variant={badgeVariant}/>
                </a>
                {manageLink}
            </li>);
    },
});
